import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// STATE AND STORE
// LIBS
import {
  getFilialPercentFormString,
  getFilialPercentConditionString
} from "../../../lib/helpers/filials";
import { sumFormat } from "../../../lib/helpers/strings";

// UI
import { Row, Col, Header, Button, Table, Section } from "../../../ui";

export default class FilialPercents extends Component {
  static propTypes = {
    filialId: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    percentsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  };

  getTableColumns = () => {
    return [
      { title: "Приоритет", suffix: "выбора условия", field: "priority" },
      {
        title: "Условие",
        suffix: "если",
        field: "condition",
        render: ({ field }) => getFilialPercentConditionString(field)
      },
      {
        title: "Источник",
        suffix: "условия",
        field: "form",
        render: ({ field }) => getFilialPercentFormString(field)
      },
      {
        title: "Цель",
        suffix: "условия",
        text: "right",
        field: "target",
        render: ({ field }) => sumFormat(field)
      },
      {
        title: "Процент",
        suffix: "тогда",
        text: "right",
        field: "percent",
        render: ({ field }) => sumFormat(field)
      }
    ];
  };

  render() {
    return (
      <div>
        <Row align="center" withMain={true}>
          <Col padding="no" main={true}>
            <Header size={4}>Проценты</Header>
          </Col>
          <Col padding="no" normal={true}>
            <Button
              size="s"
              type="as"
              as={Link}
              to={`/filials/${this.props.filialId}/percents/edit`}
            >
              {this.props.percentsList && this.props.percentsList.length
                ? "Изменить"
                : "Создать"}
              {" проценты"}
            </Button>
          </Col>
        </Row>

        <Table
          columns={this.getTableColumns()}
          data={this.props.percentsList}
          loading={this.props.loading}
        />

        <Section theme="warning">
          <strong>Внимание!</strong> Процент выбирается при выполнении условия с
          самым высоким приоритетом.
        </Section>
      </div>
    );
  }
}
